/**
 * Auth component auth flow options.
 * Treat this file as an enum.
 * @module authFlows
 * @category Auth
 * @author Dan Levy <danlevy124@gmail.com>
 */

/**
 * The sign up flow
 */
export const SIGN_UP = "SIGN_UP";

/**
 * The sign in flow
 */
export const SIGN_IN = "SIGN_IN";
